<prlw-mobile-overlay-card-ui
  *ngIf="item$ | async as item"
  [maxHeight]="85"
  [showDoneButton]="true"
  (eventClickX)="eventClose.emit()"
  (eventClickMobileButton)="eventClose.emit()"
>
  <div body class="container">
    <div class="basis-code-label">
      {{ item.basisCode
      }}<prlw-text-tag-otp
        [instrumentCode]="item.instrumentCode"
        size="medium"
      ></prlw-text-tag-otp>
    </div>
    <div class="subtitle">О базисе</div>

    <div class="label">Наименование базиса</div>
    <div class="value">{{ item.basisName }}</div>

    <div class="label">Производитель</div>
    <div class="value">{{ item.plantName }}</div>

    <div class="label">Станция отгрузки</div>
    <div class="value">{{ item.station }}</div>

    <div class="label">Код инструмента</div>
    <div class="value">{{ item.instrumentCode }}</div>

    <div class="label">Название инструмента</div>
    <div class="value">{{ item.instrumentName }}</div>
  </div>
</prlw-mobile-overlay-card-ui>
